const elem = document.querySelector('.js-calendar');

if(elem) {
	const datepicker = new Datepicker(elem, {
		weekStart: 1,
		nextArrow: '<svg version="1.1" id="arrow-next" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7 12" style="enable-background:new 0 0 7 12;" xml:space="preserve"><path fill="currentColor" d="M1,12c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4L4.6,6L0.3,1.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l5,5	c0.4,0.4,0.4,1,0,1.4l-5,5C1.5,11.9,1.3,12,1,12z"/></svg>',
	  prevArrow: '<svg version="1.1" id="arrow-prev" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 6.7 11.7" style="enable-background:new 0 0 6.7 11.7;" xml:space="preserve"><path fill="currentColor" d="M6.4,0.2c0.3,0.3,0.3,0.9,0,1.2L2,5.8l4.4,4.4c0.3,0.3,0.3,0.9,0,1.2c-0.3,0.3-0.9,0.3-1.2,0l-5-5	c-0.3-0.3-0.3-0.9,0-1.2l5-5C5.6-0.1,6.1-0.1,6.4,0.2z"/></svg>',
	  maxNumberOfDates: 0,
	  // beforeShowDay: function(date){
		 //  let curr = new Date 
			// let week = []

			// for (let i = 1; i <= 7; i++) {
			//   let first = curr.getDate() - curr.getDay() + i 
			//   let day = new Date(curr.setDate(first)).toISOString().slice(0, 10)
			//   week.push(day)
			// }     
			// // console.log(curr)

			// // instance.update(curr);
			// console.log(Datepicker.formatDate(curr,'mm-DD-yyyy','en'))
			// // Datepicker.formatDate(date, format, lang);
	  // }
	}); 
}

const elem1 = document.querySelector('.js-calendar1');

if(elem1) {
	const datepicker = new Datepicker(elem1, {
		weekStart: 1,
		nextArrow: '<svg version="1.1" id="arrow-next" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 7 12" style="enable-background:new 0 0 7 12;" xml:space="preserve"><path fill="currentColor" d="M1,12c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4L4.6,6L0.3,1.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l5,5	c0.4,0.4,0.4,1,0,1.4l-5,5C1.5,11.9,1.3,12,1,12z"/></svg>',
	  prevArrow: '<svg version="1.1" id="arrow-prev" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 6.7 11.7" style="enable-background:new 0 0 6.7 11.7;" xml:space="preserve"><path fill="currentColor" d="M6.4,0.2c0.3,0.3,0.3,0.9,0,1.2L2,5.8l4.4,4.4c0.3,0.3,0.3,0.9,0,1.2c-0.3,0.3-0.9,0.3-1.2,0l-5-5	c-0.3-0.3-0.3-0.9,0-1.2l5-5C5.6-0.1,6.1-0.1,6.4,0.2z"/></svg>',
	  maxNumberOfDates: 0,
	}); 
}